/**
 * Checks if a ticket type is sold out based on various conditions
 * @param {Object} ticketType - The ticket type object to check
 * @returns {boolean} - True if ticket type is sold out, false otherwise
 */
export default function checkIsTicketTypeSoldOut(ticketType) {
  if (!ticketType) return false;

  return (
    ticketType.isSoldOut === true ||
    ticketType.availabilityStatus === 'sold_out' ||
    (ticketType.capacity !== null &&
      ticketType.capacity !== undefined &&
      ticketType.quantitySold >= ticketType.capacity)
  );
}
